import { Component } from '@theme/component';
import { prefersReducedMotion } from '@theme/utilities';

class EditorialBeers extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (prefersReducedMotion()) return;

    this.#animateEntrance();
  }

  #animateEntrance() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    const jumbo = this.querySelector('.editorial-beers__jumbo-text-inner');
    const media = this.querySelector('.media-block');
    const content = this.querySelector('.media-with-content__content');
    const otherTargets = [media, content].filter(Boolean);

    const scrollTrigger = {
      trigger: this,
      start: 'top 65%',
      once: true,
    };

    const shared = {
      translate: '0 0',
      duration: 0.8,
      ease: 'power2.out',
    };

    if (jumbo) {
      const jumboOpacity = parseFloat(
        getComputedStyle(this).getPropertyValue('--editorial-beers-jumbo-opacity')
      ) || 0.1;

      gsap.to(jumbo, {
        ...shared,
        opacity: jumboOpacity,
        scrollTrigger,
      });
    }

    if (otherTargets.length) {
      gsap.to(otherTargets, {
        ...shared,
        opacity: 1,
        stagger: 0.12,
        delay: jumbo ? 0.12 : 0,
        scrollTrigger,
      });
    }
  }
}

if (!customElements.get('editorial-beers-component')) {
  customElements.define('editorial-beers-component', EditorialBeers);
}
